<template>
    <div>
<!--        The group named <strong>{{ $_.get(activity, "payload.name") }}</strong> was removed by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>.-->
        <span v-html="$t('notification.customerGroupRemoved', {group: $_.get(activity, 'payload.name'), user: $_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "CustomerGroupRemoved",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
